import React from "react";

export default function LevelAccessBlockedModal({
  open,
  title,
  message,
  buttonLabel = "TASKS",
  onClose,
  onTasks,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/45 px-4">
      <div className="relative w-full max-w-[340px] rounded-[24px] bg-white px-6 py-7 text-center shadow-2xl">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-[#F3F3F3] text-xl font-bold leading-none text-[#757575] hover:bg-[#E8E8E8]"
          aria-label="Close level access message"
        >
          ×
        </button>

        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#FFF1E8]">
          <span className="text-3xl" aria-hidden="true">
            ✅
          </span>
        </div>

        <h2 className="mt-4 text-[24px] font-bold leading-tight text-[#333333]">
          {title || "Complete your tasks first"}
        </h2>

        <p className="mt-2 text-[14px] leading-relaxed text-[#757575]">
          {message ||
            "Complete your practical tasks before starting another level."}
        </p>

        <button
          type="button"
          onClick={onTasks}
          className="mt-5 flex h-[40px] w-full items-center justify-center rounded-[10px] bg-[#FF914D] px-4 text-[15px] font-bold text-white hover:bg-[#E9782F]"
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  );
}